import { livescoreClient } from '@/api/livescore/client';
import { ApiH2hGet200ResponseDataH2hHomeInner } from '@/api/livescore/generated';
import { useLivescoreMatch } from '@/context/LivescoreMatchContext';
import { cn } from '@/utils/cn';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import LivescoreH2HDetailsSkeleton from './LivescoreH2HDetailsSkeleton';
import LivescoreMatchCard from '../LivescoreMatchCard/LivescoreMatchCard';
import LivescoreEntityLink from '@/components/atoms/LivescoreEntityLink/LivescoreEntityLink';

interface LastMatchesProps {
  competitorName?: string;
  between?: boolean;
  matches?: ApiH2hGet200ResponseDataH2hHomeInner[];
  showWinner?: boolean;
}

const LastMatches = ({ competitorName, matches, between, showWinner = true }: LastMatchesProps) => (
  <div>
    {competitorName ? (
      <p className="text-black dark:text-white font-light sm:text-[13px] text-[10px] mb-2">
        Ostatnie mecze: <b className="font-medium">{competitorName}</b>
      </p>
    ) : between ? (
      <p className="text-black dark:text-white font-medium sm:text-[13px] text-[10px] mb-2">Mecze Bezpośrednie</p>
    ) : null}

    <ul className="list-none pl-0 space-y-2">
      {matches?.map((match) => (
        <LivescoreMatchCard key={match.id} match={match} showWinnerStatus={showWinner} />
      ))}
    </ul>
  </div>
);

const LivescoreH2HDetails = () => {
  const { match, h2h, setH2H } = useLivescoreMatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getH2H() {
      setLoading(true);

      console.log(match.sport_event.competitors.find(({ qualifier }) => qualifier === 'home')?.id ?? '');
      console.log(match.sport_event.competitors.find(({ qualifier }) => qualifier === 'away')?.id ?? '');

      const response = await livescoreClient.apiH2hGet({
        homeId: match.sport_event.competitors.find(({ qualifier }) => qualifier === 'home')?.id ?? '',
        awayId: match.sport_event.competitors.find(({ qualifier }) => qualifier === 'away')?.id ?? '',
      });

      setH2H(response.data.data.h2h);
      setLoading(false);
    }

    if (!h2h) {
      getH2H();
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <LivescoreH2HDetailsSkeleton />;
  }

  return (
    <div className="space-y-4">
      <div>
        <LastMatches
          competitorName={match.sport_event.competitors.find(({ qualifier }) => qualifier === 'home')?.name ?? ''}
          matches={h2h?.home}
        />
        <LivescoreEntityLink
          href={`/livescore/team/${match.sport_event.competitors.find(({ qualifier }) => qualifier === 'home')?.id}`}
          className="w-fit mx-auto flex items-center justify-center gap-1.5 text-primary-600 font-semibold sm:text-[12px] text-[9px] mt-2"
        >
          Pokaż więcej meczów{' '}
          <ChevronDownIcon width={14} height={14} className="mt-0.5 sm:w-[12px] w-[10px]" strokeWidth={3} />
        </LivescoreEntityLink>
      </div>
      <div>
        <LastMatches
          competitorName={match.sport_event.competitors.find(({ qualifier }) => qualifier === 'away')?.name ?? ''}
          matches={h2h?.away}
        />
        <a
          href={`/livescore/team/${match.sport_event.competitors.find(({ qualifier }) => qualifier === 'away')?.id}`}
          className="w-fit mx-auto flex items-center justify-center gap-1.5 text-primary-600 font-semibold sm:text-[12px] text-[9px] mt-2"
        >
          Pokaż więcej meczów{' '}
          <ChevronDownIcon width={14} height={14} className="mt-0.5 sm:w-[12px] w-[10px]" strokeWidth={3} />
        </a>
      </div>
      <LastMatches between matches={h2h?.away} showWinner={false} />
    </div>
  );
};

export default LivescoreH2HDetails;
